import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quick-pack-service',
  templateUrl: './quick-pack-service.component.html',
  styleUrls: ['./quick-pack-service.component.scss']
})
export class QuickPackServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
